import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, ShoppingCart, User, Phone } from 'lucide-react';
import Logo from './Logo';
import Navigation from './Navigation';
import { useCart } from '../context/CartContext';
import { useBrand } from './BrandProvider';

const Header = () => {
  const navigate = useNavigate();
  const { cartItems } = useCart();
  const brand = useBrand();
  const [searchQuery, setSearchQuery] = useState('');
  
  // Calculer le nombre total d'articles (somme des quantités)
  const totalItemsCount = cartItems.reduce((total, item) => total + (item.quantity || 1), 0);

  return (
    <>
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <Logo clickable={true} />

            {/* Search Bar */}
            <div className="flex-1 max-w-2xl">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Rechercher un produit, une référence..."
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-celadon"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <button className="absolute right-0 top-0 bottom-0 bg-celadon text-white px-6 rounded-r-lg hover:bg-celadon-light transition-colors">
                  Chercher
                </button>
              </div>
            </div>

            {/* Phone, User & Cart */}
            <div className="flex items-center gap-4">
              {/* Phone Number */}
              <a 
                href={`tel:${brand.contact.phone}`}
                className="hidden md:flex items-center gap-2 bg-celadon/10 hover:bg-celadon/20 text-celadon px-4 py-2 rounded-lg transition-colors"
              >
                <Phone size={20} className="animate-pulse" />
                <span className="font-bold text-lg">{brand.contact.phoneDisplay}</span>
              </a>
              
              <button 
                onClick={() => navigate('/pro/login')}
                className="flex items-center gap-2 text-gray-700 hover:text-gray-900 transition-colors"
                title="Espace PRO"
              >
                <User size={24} />
              </button>
              <button 
                onClick={() => navigate('/panier')}
                className="flex items-center gap-2 text-gray-700 hover:text-gray-900 relative"
              >
                <ShoppingCart size={24} />
                <span className="absolute -top-2 -right-2 bg-celadon text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">{totalItemsCount}</span>
                <span className="font-medium">PANIER</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Navigation Component */}
      <Navigation />
    </>
  );
};

export default Header;
